import { getUserEmail, getUserId } from "helpers/local_storage"
import { getSavedWsCode, getWsCodeFromUrl } from "helpers/wsCode.helper"

/** Umami distinct id max length — https://umami.is/docs/guides/identify-logged-in-users */
const UMAMI_DISTINCT_ID_MAX = 50

/**
 * Gán Distinct ID cho phiên Umami (hiển thị trên dashboard thay cho UUID ẩn danh).
 * Dùng email làm `id` (cắt 50 ký tự) và gửi thêm field `email` để profile đầy đủ.
 */
export const umamiIdentifySession = (options: {
  email: string
  name?: string
  internalUserId?: string
}) => {
  const email = (options.email || "").trim()
  if (!email) return

  const payload = {
    id: email.slice(0, UMAMI_DISTINCT_ID_MAX),
    email,
    ...(options.name ? { name: options.name } : {}),
    ...(options.internalUserId ? { user_id: options.internalUserId } : {}),
  }

  if (typeof window.umami?.identify === "function") {
    window.umami.identify(payload)
  } else {
    // Script chưa load xong, retry sau khi load
    setTimeout(() => {
      if (typeof window.umami?.identify === "function") {
        window.umami.identify(payload)
      }
    }, 3000)
  }
}

/**
 * Gán data-tag trên script Umami để filter theo Tag trên dashboard.
 * Umami đọc data-tag mỗi lần gửi event nên có thể set sau khi biết workspace code.
 */
export const umamiSetTag = (tag: string) => {
  if (!tag) return
  const script = document.querySelector<HTMLScriptElement>(
    "script[data-website-id]"
  )
  if (script) {
    console.debug("Setting Umami tag:", tag)
    script.dataset.tag = tag
  }
}

export const umamiTracking = (
  eventName: string,
  metadata?: Record<string, unknown>
) => {
  if (typeof window.umami !== "undefined") {
    const requestMetadata = metadata || {}
    const email = requestMetadata?.email || getUserEmail() || ""
    if (email) {
      requestMetadata.email = email
    }
    const user_id = metadata?.user_id || getUserId() || ""
    if (user_id) {
      requestMetadata.user_id = user_id
    }
    const workspace_code = getWsCodeFromUrl() || getSavedWsCode() || ""
    if (workspace_code) {
      requestMetadata.workspace_code = workspace_code
    }
    window.umami.track(eventName, {
      ...requestMetadata,
    })
  }
}
